<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Uredite uporabnika {{ user.moniker }}
    </h2>

    <UserForm
      @save="save"
      @cancel="cancel"
      :user="user"
      :userTypes="userTypes"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { loadItem, saveItem } from '@/utils/crudFunctions'
import UserForm from '@/components/UserForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    UserForm
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  computed: {
    ...mapGetters('auth', ['childCompanyUserIsTaken']),
    user () {
      return this.$store.state.users.items[this.id]
    },
    userTypes () {
      return objectToArray(this.$store.state.userTypes.items)
    },
    usersRouteName () {
      return this.childCompanyUserIsTaken ? 'MyCompanyUsers' : 'Users'
    }
  },
  methods: {
    ...mapActions('users', ['loadItem', 'saveItem']),
    ...mapActions('userTypes', { loadUserTypes: 'loadItems' }),
    save ({ data }) {
      saveItem(data, this.usersRouteName, this)
    },
    cancel () {
      this.$router.push({ name: this.usersRouteName })
    }
  },
  created () {
    Promise.all([
      this.loadUserTypes(),
      loadItem(this)
    ])
      .then(values => {
        this.asyncDataStatus_fetched()
      })
  }
}
</script>
